import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/price-to-sales-calculator',
  component: () => import('../../routes/PriceToSalesCalculator.svelte'),
  card: {
    id: 'price-to-sales-calculator',
    title: 'Price-to-Sales (P/S) Ratio',
    description: 'Evaluate stock valuation using the price-to-sales ratio, PSG ratio, and growth projections.',
    icon: 'bar_chart',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/price-to-sales-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Price-to-Sales (P/S) Ratio Calculator – Stock Valuation Tool',
    description:
      'Calculate the price-to-sales (P/S) ratio, PSG ratio, and forward P/S to evaluate whether a stock is overvalued or undervalued based on revenue growth.',
  },
};

export default meta;
